import { render, staticRenderFns } from "./EcommerceGoalOverview.vue?vue&type=template&id=04c99ee2&"
import script from "./EcommerceGoalOverview.vue?vue&type=script&lang=js&"
export * from "./EcommerceGoalOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports